
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Nein, einzeln, ohne einen Tropfen Schleim oder Speichel, ist der Erreger
  ungefährlich. Die kugelförmigen Viren sind ungefähr so breit wie ein Tausendstel eines Haares. Damit sind sie nur mit dem Elektronenmikroskop zu erkennen.
  Aber Viren sind meistens zusammen unterwegs und werden in Sekretklumpen,
  Tropfen und Aerosolen ausgehustet. Beim Sars-Virus mussten damals 100 auf
  einmal in die Lunge eindringen, um dem Menschen ernsthaft gefährlich zu
  werden.
    </p>
    <Image className='cbImage' file={require("images/illus_hair.jpg")} mdxType="Image" />
    <p>
  <Link href='https://www.sciencemediacentre.org/expert-reaction-to-questions-about-covid-19-and-viral-load/' mdxType="Link">Experten</Link> schätzen, dass schon mehrere 100 bis maximal 1000 infektiöse
  Sars-CoV-2-Viruspartikel ausreichen, um jemanden zu infizieren. Auf Basis
  dieser Zahl berechnete Erin Bromage, Biologieprofessor an der Universität von
  Massachusetts, in einem <Link href='https://www.erinbromage.com/post/the-risks-know-them-avoid-them' mdxType="Link">Beitrag</Link>, wie diese Menge über die Schleimhäute oder
  Augen aufgenommen werden kann, um jemanden krank zu machen.
    </p>
    <p>
  Husten und Niesen: Einmal Husten setzt etwa 3000 Tröpfchen frei, die meisten
  sind gross und fallen schnell auf den Boden, aber viele bleiben in der Luft
  und können sich in wenigen Sekunden durch einen Raum bewegen. Einmal Niesen
  setzt etwa 30’000 Tröpfchen frei, die meisten sind klein und bewegen sich
  leicht durch einen Raum. Wenn eine Person infiziert ist, können die Tröpfchen
  bei nur einmal Husten oder Niesen bis zu 200 Millionen Viruspartikel
  enthalten, die sich alle in der Umgebung verteilen können.
    </p>
    <p>
  Atmen und Sprechen: Ein einziger Atemzug setzt 50 bis 5000 Tröpfchen frei –
  Sprechen erhöht die Freisetzung um das Zehnfache. Die meisten dieser Tröpfchen
  haben eine geringe Geschwindigkeit und fallen schnell auf den Boden. Die durch
  die Atmung freigesetzten Atmungströpfchen enthalten nur geringe Virusmengen.
  Bei der Grippe ist es so: Eine infizierte Person kann bis zu 33 infektiöse
  Viruspartikel pro Minute freisetzen, beim Sprechen wären es maximal 330.
    </p>
    <p>Bromage zieht daraus folgende Schlussfolgerung:</p>
    <p>
  «Wenn eine Person hustet oder niest, gelangen 200 Millionen Viruspartikel
  überallhin. Manche Viren hängen einige Minuten in der Luft, die meisten fallen
  auf den Boden. Wenn eine Person eine andere anhustet, ist es relativ einfach,
  1000 Viruspartikel einzufangen. Aber selbst wenn man einen Raum betritt, in
  welchem vorher jemand geniest oder gehustet hat, ist es relativ leicht, durch
  ein paar Atemzüge diese Menge an Partikeln einzufangen. Niesen und husten
  stösstso viele Viren aus, dass ein ganzer Raum mit Menschen infiziert werden
  könnte. In einem Gespräch von Angesicht zu Angesicht bräuchte es für die Dosis
  von 1000 Viruspartikel ungefähr 5 Minuten.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;